import { render, staticRenderFns } from "./ResendCodeCard.vue?vue&type=template&id=1c750875"
import script from "./ResendCodeCard.vue?vue&type=script&lang=ts"
export * from "./ResendCodeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports